import { getUiText, interpolate } from "../data/translations";
import { useLanguage } from "../context/LanguageContext";

export const useI18n = () => {
  const { language, preference, setPreference } = useLanguage();

  const t = (template: string, values?: Record<string, string>) =>
    values ? interpolate(template, values) : template;

  return {
    language,
    preference,
    setPreference,
    text: {
      nav: getUiText(language, "nav"),
      footer: getUiText(language, "footer"),
      home: getUiText(language, "home"),
      about: getUiText(language, "about"),
      contact: getUiText(language, "contact"),
      gallery: getUiText(language, "gallery"),
      business: getUiText(language, "business"),
    },
    t,
  };
};
